import { MersDeactivationKind } from 'constants/loanActionEditor';

export const LIQUIDATION_DATE_HELP = {
  [MersDeactivationKind.PAID_IN_FULL]: 'The date the servicer processed the payoff.',
  [MersDeactivationKind.FORECLOSURE_COMPLETE]: 'The date the foreclosure was completed.',
};

export const CONFIRMATION_NOTE =
  'MERS confirms the deactivation the day after it receives the file.';
